import React, { ReactNode, useEffect, useRef, useState } from 'react';

interface Props {
  children: ReactNode;
  containerClass?: string;
  id: string;
}

const hasFirstChildGrey = 'blog-portfolio-section-cs-f';
const hasLastChildGrey = 'blog-portfolio-section-cs-l';
const summaryCardOffset = 'summary-card-offset';

export const ContainerBlogPortfolio = ({ id, children, containerClass = '' }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [classes, setClasses] = useState(['']);

  const scrollToElement = (hash: string) => {
    const scrollTarget = document.querySelector(hash);
    const topOffset = 100;

    const elementPosition = scrollTarget?.getBoundingClientRect().top;

    if (elementPosition && window.innerWidth >= 1024) {
      const offsetPosition = elementPosition - topOffset;

      window.scrollBy({
        top: offsetPosition,
        behavior: 'smooth',
      });
    } else if (elementPosition && window.innerWidth < 1024) {
      scrollTarget.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const contentLink = [...ref?.current.getElementsByTagName('a')];

    setClasses([...[ref.current?.classList]]);

    contentLink.forEach((item) => {
      item.addEventListener('click', (e: Event) => {
        if (item.hash) {
          e.preventDefault();
          scrollToElement(item.hash);
        }
      });
    });
  }, []);

  useEffect(() => {
    if (
      ref.current?.parentElement?.parentElement?.classList.contains(hasLastChildGrey) &&
      ref.current?.parentElement?.parentElement?.nextElementSibling?.classList.contains(hasFirstChildGrey)
    ) {
      ref.current.parentElement.parentElement.classList.add(summaryCardOffset);
    }
  }, [classes]);

  return (
    <div className={`container ${containerClass}`}>
      <div className="blog-portfolio-section-inner" id={id} ref={ref}>
        {children}
      </div>
    </div>
  );
};
